import { useState, useEffect } from 'react';

/** 로컬 미리보기(blob:)까지 허용 */
export function isDisplayableImageUrl(src) {
  if (typeof src !== 'string') return false;
  const s = src.trim();
  if (!s) return false;
  return (
    s.startsWith('http://') ||
    s.startsWith('https://') ||
    s.startsWith('data:') ||
    s.startsWith('blob:')
  );
}

export const DEFAULT_AVATAR_DATA_URI =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"><rect fill="#e2e8f0" width="64" height="64"/><text x="50%" y="54%" dominant-baseline="middle" text-anchor="middle" fill="#64748b" font-size="28" font-family="sans-serif">?</text></svg>'
  );

/** 깔끔한 사람 placeholder 아이콘 (currentColor 상속, 1em 크기) */
export function PersonIcon({ className, style }) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      style={{ display: 'block', ...style }}
    >
      <path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 2c-4.42 0-8 2.69-8 6 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 0-3.31-3.58-6-8-6Z" />
    </svg>
  );
}

/**
 * URL이면 img로 로드, 실패 시·URL이 아니면 placeholder(이미지 또는 이모지) 표시
 */
export default function SafeAvatar({
  src,
  alt = '',
  className,
  fallbackClassName,
  fallback,
  as: FallbackTag = 'span',
  placeholderImageSrc,
  imgProps = {},
}) {
  const [loadFailed, setLoadFailed] = useState(false);
  const isUrl = isDisplayableImageUrl(src);

  useEffect(() => {
    setLoadFailed(false);
  }, [src]);

  if (isUrl && !loadFailed) {
    return (
      <img
        src={src.trim()}
        alt={alt}
        className={className}
        onError={() => setLoadFailed(true)}
        {...imgProps}
      />
    );
  }

  if (placeholderImageSrc) {
    return <img src={placeholderImageSrc} alt={alt} className={className} {...imgProps} />;
  }

  // src 가 URL 이 아닌 문자열(예: 닉네임 첫 글자) 이면 그대로 텍스트 노출.
  // 그 외(빈 값/null/매칭 안 되는 입력) 는 사람 모양 PersonIcon SVG.
  const text =
    !isUrl && typeof src === 'string' && src.trim() && !isDisplayableImageUrl(src)
      ? src
      : fallback;

  return (
    <FallbackTag className={fallbackClassName}>
      {text || <PersonIcon className="safe-avatar-person-icon" />}
    </FallbackTag>
  );
}
